import apiSlice from './ApiSlice';

export const goalApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // GET
        getGoalCategories: builder.query({
            providesTags: ["goal-category"],
            query: (body) => {
                return {
                    url: "/goal-category/",
                    method: "POST",
                    body,
                };
            },
        }),
        //getAll
        getAllGoalCategories: builder.query({
            providesTags: ["goal-category"],
            query: () => {
                return {
                    url: "/goal-category/",
                    method: "GET",
                };
            },
        }),
        //Add
        addGoalCategory: builder.mutation({
            invalidatesTags: ["goal-category"],
            query: (body) => {
                return {
                    url: "/goal-category/add",
                    method: "POST",
                    body,
                };
            },
        }),
        // EDIT
        editGoalCategoryies: builder.mutation({
            invalidatesTags: ["goal-category"],
            query: ({ body, goalId }: any) => {
                return {
                    url: `/goal-category/${goalId}`,
                    method: "PUT",
                    body,
                };
            },
        }),
        //Single View
        getGoalCategoryById: builder.query({
            providesTags: ["goal-category"],
            query: (goalId: any) => {
                return {
                    url: `/goal-category/${goalId}`,
                    method: "GET",
                };
            },
        }),
        //Delete
        deleteGoalCateGory: builder.mutation({
            invalidatesTags: ["goal-category"],
            query: (goalId: any) => {
                return {
                    url: `/goal-category/${goalId}`,
                    method: "DELETE",
                };
            },
        }),
    }),
});

export const { useGetGoalCategoriesQuery, useAddGoalCategoryMutation, useEditGoalCategoryiesMutation, useGetGoalCategoryByIdQuery, useDeleteGoalCateGoryMutation, useGetAllGoalCategoriesQuery } = goalApi;